import axios from 'axios';
import {
  LOGIN_ADD_FEATURE_BEGIN,
  LOGIN_ADD_FEATURE_SUCCESS,
  LOGIN_ADD_FEATURE_FAILURE,
  LOGIN_ADD_FEATURE_DISMISS_ERROR,
} from './constants';

export function addFeature(args = {}) {
  return (dispatch) => {
    dispatch({
      type: LOGIN_ADD_FEATURE_BEGIN,
    });
    // console.log("add feature action", args);
    const { body } = args;
    // const token = process.env.REACT_APP_TOKEN;
    const options = {
      headers: {
        // 'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}line-items/`,
        body,
        options,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: LOGIN_ADD_FEATURE_SUCCESS,
            data: res.data.lin,
          });
          resolve(res);
          // console.log("data", res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: LOGIN_ADD_FEATURE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddFeatureError() {
  return {
    type: LOGIN_ADD_FEATURE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_ADD_FEATURE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        addFeaturePending: true,
        addFeatureError: null,
      };

    case LOGIN_ADD_FEATURE_SUCCESS:
      // The request is success
      return {
        ...state,
        addFeaturePending: false,
        addFeatureError: null,
      };

    case LOGIN_ADD_FEATURE_FAILURE:
      // The request is failed
      return {
        ...state,
        addFeaturePending: false,
        addFeatureError: action.data.error,
      };

    case LOGIN_ADD_FEATURE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        addFeatureError: null,
      };

    default:
      return state;
  }
}
